<template>
    <div class="gutter-example">
        <a-row :gutter="16">
            <a-col class="gutter-row" :lg="16" :sm="12">
                <a-card>
                    <a-row  :gutter="16" class="mb-2">
                        <a-col class="gutter-row" :lg="10" :sm="24" style="text-align: left;">
                            <h4>Order List</h4>
                        </a-col>
                        <a-col class="gutter-row" :lg="14" :sm="24" style="margin-top: -10px">
                            <a-row :gutter="10">
                                <a-col :span="12">
                                    <a-select size="large"
                                        style="width: 100%"
                                        :allowClear="true"
                                        @change="siduleSelect"
                                        show-search
                                        :filter-option="filterOption"
                                        :dropdownMatchSelectWidth="false"
                                        placeholder="Delivery Schedule">
                                        <template v-for="sidule in delivarySiduleList" >
                                            <a-select-option :key="sidule.id" :value="sidule.value">
                                                {{sidule.value}}
                                            </a-select-option>
                                        </template>
                                    </a-select>
                                </a-col>
                                <a-col :span="12">
                                    <a-select size="large"
                                        style="width: 100%"
                                        :allowClear="true"
                                        @change="zoneSelect"
                                        show-search
                                        :dropdownMatchSelectWidth="false"
                                        :filter-option="filterOption"
                                        placeholder="Search by zone">
                                        <template v-for="zone in zones" >
                                            <a-select-option :key="zone.id" :value="zone.id">
                                                {{zone.name}}
                                            </a-select-option>
                                        </template>
                                    </a-select>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>

                    <a-table
                            :columns="columns"
                            :data-source="orders"
                            :row-selection="rowSelection"
                            :pagination="{ pageSize: 10 }"
                            rowKey="id"
                            :scroll="{ x: 'calc(600px + 50%)' }"
                        > <!-- x: 'calc(600px + 50%)', -->

                        <span slot="total_products" slot-scope="text, record">
                            {{record.details.length}}
                        </span>

                        <span slot="action" slot-scope="text, record"> <!-- slot-scope="text, record" -->
                            <a-button type="primary" class="btn btn-xs" size="small" @click="showDrawer(record)">
                                View Details
                            </a-button>
                        </span>

                        
                        <span slot="customer_info" slot-scope="text, record">
                            <strong> {{record.customer.name}} </strong>
                            <br/>
                            {{record.customer_address}}
                        </span>

                        <span slot="location" slot-scope="text, record">
                            <strong>Hub:</strong> {{record.hub.name}}
                            <br/>
                            <strong>Zone:</strong> {{record.zone.name}}
                        </span>
                        
                    </a-table>
                </a-card>
            </a-col>
            <a-col class="gutter-row" :lg="8" :sm="12">
                <a-card>
                    <h4>Selected Order List</h4>
                    <a-table
                        :columns="selectedColumns"
                        :data-source="selectedData"
                        :pagination="false"
                        :scroll="{ y: 600 }"
                        rowKey="unique_id"
                    >
                        <span slot="total_products" slot-scope="text, record">
                            {{record.details.length}}
                        </span>
                    </a-table>
                </a-card>
            </a-col>
        </a-row>
        <a-drawer
            title="Order Details"
            width="90%"
            :visible="visible"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
        >
            <orderDetailsModal :order="selectedOrder"></orderDetailsModal>
        </a-drawer>
    </div>
</template>

<script>
    import { ORDER_LIST, ZONE_LIST, DELIVARY_SCHEDULE_LIST } from "../../../script/api";
    import { getData } from "../../../script/api-service";
    import orderDetailsModal from "./OrdeDetailsModal.vue"
    
    const columns = [
        {
            title: 'Order ID',
            width: 100,
            dataIndex: 'unique_id',
        },
        {
            title: "Customer",
             width: 130,
            // dataIndex: 'customer.name'
            scopedSlots: { customRender: 'customer_info' }
        },
        {
            title: "Location",
            width: 120,
            scopedSlots: { customRender: 'location' },
            // dataIndex: 'zone.name'
        },
        {
            title: 'Delivary Schedule',
            width: 150,
            dataIndex: "delivery_schedule"
        },
        {
            title: 'Action',
            key: 'action',
            width: 200,
            scopedSlots: { customRender: 'action' },
        }
    ];

    const selectedColumns = [
        {
            title: 'Order ID',
            dataIndex: 'unique_id',
            key: 'unique_id'
        },
        {
            title: 'Total Products',
            scopedSlots: { customRender: 'total_products' },
        }
    ];

    export default {
        props: ["orderDate", "userInfo", "hubId"],
        data() {
            return {
                columns,
                selectedData: [],
                selectedColumns,
                visible: false,
                orders: [],
                selectedOrder: null,
                zones: [],
                selectedZone: null,
                userHubId: null,
                delivarySiduleList: [],
                selectedSidule: null
            };
        },
        components: {
            orderDetailsModal
        },
        computed: {
            rowSelection() {
                return {
                    onChange: (selectedRowKeys, selectedRows) => {
                        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                        this.selectedData = selectedRows;
                        this.$parent.selectedOrderList(selectedRows);
                    },
                };
            }
        },
        watch: {
            orderDate() {
                this.getOrderList();
            },
            hubId() {
                this.getOrderList();
            },
            userInfo(newVal) {
                this.userHubId = newVal && newVal.hub && newVal.hub.id ? newVal.hub.id : null;
                this.getZoneList();
            }
        },
        methods: {
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            showDrawer(order) {
                this.visible = true;
                this.selectedOrder = order;
            },
            onClose() {
                this.visible = false;
            },
            async getOrderList() {
                let url = ORDER_LIST + `?order_status_ids=1,2,9&paginate=false&delivery_date=${this.orderDate}&is_consignment=1`;
                if (this.selectedZone) url = url + '&zone_id=' + this.selectedZone;
                if (this.selectedSidule) url = url + '&delivery_schedule=' + this.selectedSidule;
                if (this.hubId) url = url + '&hub_id=' + this.hubId;

                let res = await getData(url);

                if (res) {
                    let masterData = res.data?.data,
                        orders = [];

                    masterData.forEach(data => {
                        if (!(data.payment_type === "SSLCOMMERZ" && data?.order_status?.name === "Pending")) orders.push(data);
                    });

                    this.orders = orders;
                }
            },
            async getZoneList() {
                let url = ZONE_LIST + '?status=1';

                if (this.hubId || this.userHubId) {
                    url = url + '&hub_id=' + (this.hubId || this.userHubId) ;
                }

                let res =  await getData(url);

                if (res) {
                    let masterData = res.data.data;
                    
                    console.log("masterData", masterData);

                    this.zones = masterData;
                }
            },
            async getDelivarySiduleList() {
                let res = await getData(DELIVARY_SCHEDULE_LIST);

                if (res) {
                    this.delivarySiduleList = res.data.data.schedules;
                }
            },
            zoneSelect(value) {
                this.selectedZone = value;
                this.getOrderList();
            },
            siduleSelect(value) {
                this.selectedSidule = value;
                this.getOrderList();
            }
        },
        mounted() {
            // this.getOrderList();
            // this.getZoneList();
            this.getDelivarySiduleList()
        },
    };
</script>

<style scoped>
    .main-footer {
        z-index: -1000;
    }
</style>